import styled from 'styled-components'

export const UserIconContainer = styled.div`
	display: flex;
	justify-content: center;
`
